import React, { useEffect, useState } from "react";
import axios from "axios";
import UpdateBonus from "./UpdateBonus";
import { Link } from "react-router-dom";
import ReactQuill from "react-quill"; // ReactQuill ইম্পোর্ট
import "react-quill/dist/quill.snow.css"; // Quill এর স্টাইল ইম্পোর্ট
import { config } from "../../../../../config";

const apiUrl = config.apiUrl;
const imageUrl = config.imageUrl;

const ViewBonus = () => {
  const [bonuses, setBonuses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingBonus, setEditingBonus] = useState(null);
  const [formData, setFormData] = useState({
    slug: "",
    headline: "",
    offer: ""
  });

  // Fetch bonuses from API
  useEffect(() => {
    const fetchBonuses = async () => {
      try {
        const response = await axios.get(`${apiUrl}/bonuses`);
        setBonuses(response.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching bonuses:", err);
        setError("Failed to load bonuses.");
        setLoading(false);
      }
    };

    fetchBonuses();
  }, []);

  // Handle Delete
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this bonus?")) {
      try {
        await axios.delete(`${apiUrl}/bonusdelete/${id}`);
        setBonuses((prev) => prev.filter((bonus) => bonus.id !== id));
      } catch (err) {
        console.error("Error deleting bonus:", err);
        setError("Failed to delete bonus.");
      }
    }
  };

  // Handle Edit Button Click
  const handleEditClick = (bonus) => {
    setEditingBonus(bonus.id);
    setFormData({
      slug: bonus.slug,
      headline: bonus.headline,
      offer: bonus.offer
    });
  };

  // Handle Input Changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleQuillChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      offer: value || "", // খালি ভ্যালুর জন্য "" সেট করুন
    }));
  };

  // Handle Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!editingBonus) {
      setError("No bonus selected for editing.");
      return;
    }

    try {
      await axios.put(`${apiUrl}/bonusesupdate/${editingBonus}`, formData);

      alert("Bonus updated successfully");
      setBonuses((prev) =>
        prev.map((bonus) =>
          bonus.id === editingBonus ? { ...bonus, ...formData } : bonus
        )
      );
      setEditingBonus(null); // Clear editing state
    } catch (err) {
      console.error("Error updating bonus:", err?.response?.data?.message);
      setError("Failed to update bonus.");
    }
  };

  if (loading && !editingBonus) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-6 max-w-6xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4 text-center">Bonus List</h2>
      {error && <p className="text-red-500 text-center mb-4">{error}</p>}

      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr>
            <th className="border border-gray-300 px-4 py-2">Slug</th>
            <th className="border border-gray-300 px-4 py-2">Headline</th>
            <th className="border border-gray-300 px-4 py-2">Offer Preview</th>
            <th className="border border-gray-300 px-4 py-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {bonuses.map((bonus) => (
            <tr key={bonus.id}>
              <td className="border border-gray-300 px-4 py-2">{bonus.slug}</td>
              <td className="border border-gray-300 px-4 py-2">{bonus.headline}</td>
              <td className="border border-gray-300 px-4 py-2">
                {bonus.offer?.substring(0, 50)}...
              </td>
              <td className="flex flex-col gap-2 border border-gray-300 px-4 py-2">
                <button
                  onClick={() => handleEditClick(bonus)}
                  className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(bonus.id)}
                  className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
                >
                  Delete
                </button>
                <Link 
                  to={`/${bonus.slug}`} 
                  className="bg-green-600 text-white px-3 py-1 rounded hover:bg-green-700 text-center"
                >
                  View
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {editingBonus && (
         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center p-4 z-50 max-h-screen overflow-y-auto">
          <div className="p-6 mx-auto bg-white shadow rounded-lg min-w-[800px]">
            <UpdateBonus
              formData={formData}
              handleChange={handleChange}
              handleQuillChange={handleQuillChange}
              handleSubmit={handleSubmit}
              loading={loading}
              error={error}
              onCancel={() => setEditingBonus(null)} // Cancel editing
            />
          </div>
        </div>
      )}
      
    </div>
  );
};

export default ViewBonus;